/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './TableWithOverview.scss';

const TableWithOverview = ({ OverviewComponent, children, overviewRow, ...rest }) => {
  const [SwipeableViews, setSwipeableViews] = useState(null);

  useEffect(() => {
    async function loadLib() {
      setSwipeableViews(await import(/* webpackChunkName: "react-swipeable-views" */ 'react-swipeable-views'));
    }

    loadLib();
  }, []);

  if (!SwipeableViews) {
    return <div />;
  }

  return (
    <SwipeableViews.default
      className="grb-table-with-overview"
      axis="x"
      index={overviewRow && OverviewComponent ? 1 : 0}
      disabled
    >
      {children}
      {OverviewComponent && (
        <OverviewComponent {...rest} overviewRow={overviewRow} />
      )}
    </SwipeableViews.default>
  );
};

TableWithOverview.propTypes = {
  viewService: PropTypes.shape({
    getComponent: PropTypes.func,
  }).isRequired,
  children: PropTypes.node.isRequired,
  OverviewComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  overviewRow: PropTypes.shape({}),
};

TableWithOverview.defaultProps = {
  OverviewComponent: undefined,
  overviewRow: undefined,
};

export default TableWithOverview;
